import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LetDirective } from '@ngrx/component';
import { AccountUsersModule } from '@capital-access/account/users';
import { CommonBadgesModule } from '@capital-access/common/components';
import { CommonFormattingModule } from '@capital-access/common/formatting';
import { CommonLocalizationModule } from '@capital-access/common/localization';
import { FireflyPopoverModule, FireflyTooltipModule } from '@capital-access/firefly/components';
import { CompanyProfilesIconComponent } from './components/company-profiles-icon/company-profiles-icon.component';
import { ContactProfilesIconComponent } from './components/contact-profiles-icon/contact-profiles-icon.component';
import { CrmFieldIconComponent } from './components/crm-field-icon/crm-field-icon.component';
import { CrmIconComponent } from './components/crm-icon/crm-icon.component';
import { ExcludedFromMailComponent } from './components/excluded-from-mail/excluded-from-mail.component';
import { OrderPortfolioManagersPipe } from './components/portfolio-managers/order-portfolio-managers.pipe';
import { PortfolioManagersComponent } from './components/portfolio-managers/portfolio-managers.component';
import { ProfilePreviewLinkModule } from './components/preview-link/profile-preview-link.module';
import { ProfilePreviewLinkComponent } from './components/preview-link/profile-preview-link.component';
import { PrimaryContactIconComponent } from './components/primary-contact-icon/primary-contact-icon.component';
import { PrimaryContactsAtProfilesIconComponent } from './components/primary-contacts-at-profiles-icon/primary-contacts-at-profiles-icon.component';
import { RecordSourceComponent } from './components/record-source/record-source.component';
import { RecordSourceExplanationModalComponent } from './components/record-source-explanation-modal/record-source-explanation-modal.component';
import { PROFILE_COMPONENTS_COMMON_LOCALIZATION_SCOPE } from './models/constants';

const components = [
  CrmFieldIconComponent,
  PrimaryContactIconComponent,
  CrmIconComponent,
  ExcludedFromMailComponent,
  CompanyProfilesIconComponent,
  ContactProfilesIconComponent,
  PrimaryContactsAtProfilesIconComponent,
  RecordSourceComponent,
  PortfolioManagersComponent,
  RecordSourceExplanationModalComponent
];

@NgModule({
  imports: [
    CommonLocalizationModule.forFeature(PROFILE_COMPONENTS_COMMON_LOCALIZATION_SCOPE),
    CommonModule,
    AccountUsersModule,
    CommonFormattingModule,
    CommonBadgesModule,
    FireflyTooltipModule,
    FireflyPopoverModule,
    LetDirective,
    OrderPortfolioManagersPipe,
    ProfilePreviewLinkModule
  ],
  declarations: [...components],
  exports: [...components, ProfilePreviewLinkComponent]
})
export class ProfilesComponentsCommonModule {}
